import React from 'react';
import { LIMITED_READ } from '../../../constants/AccountCapability';
import { AvailableAmount } from './AvailableAmount';
import { AccountSummaryText } from './AccountSummaryText';

export const AccountInfo = ({
  account,
  balances,
  accountInterestRegularSaverText = '',
}) => {
  return account.actionsAvailable[LIMITED_READ] ? (
    ''
  ) : (
    <div className="account-summary__info">
      <dl>
        <dt>Account balance</dt>
        <dd className="account-summary__info__balance">
          <span className="u-visually-hidden off-screen">Current Balance</span>
          {balances.currentBalance ? balances.currentBalance : 'unavailable'}
        </dd>

        <dt>Account available balance</dt>
        <dd className="account-summary__info__balance-available">
          <AvailableAmount
            account={account}
            availableBalance={balances.availableBalance}
          />
        </dd>
        <dt>Overdraft / Saving interest rate</dt>
        <dd className="account-summary__info__overdraft-int-rate">
          <AccountSummaryText
            account={account}
            accountInterestRegularSaverText={accountInterestRegularSaverText}
          />
        </dd>
      </dl>
    </div>
  );
};
